module.exports = __webpack_public_path__ + "img/StempelkartenIcon.2b5a5025.png";